
import {throwError as observableThrowError,  Observable ,  Subject } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
import { StorageService } from '../services/storage.service';
import { AuthService } from '../services/auth.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private auth: AuthService,
    private storage: StorageService,
    @Inject('API_BASE_URL') private apiBaseUrl: string,
    @Inject('BASE_URL') private baseUrl: string
  ) { }

  configureRequest(request: HttpRequest<any>) {
    var token = this.storage.getItem('token');

    let headers = request.headers;
    headers = headers.append('Authorization', 'Bearer ' + token);

    request = request.clone({ headers });

    return request;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    var token = this.storage.getItem("token");
    if ((token === null || token === undefined) && !request.url.toLowerCase().startsWith(this.baseUrl.concat('identity').toLowerCase())) {
      this.router.navigate(['/auth/login']);
      return this.abandonWithError('API error: Not authenticated');
    }

    if (!request.url.toLowerCase().startsWith(this.apiBaseUrl.toLowerCase())) {
      return next.handle(request); // Not an API call so is not our responsibility.
    }

    // Add bearer token to the request.
    request = this.configureRequest(request);

    // Handle expired token
    var token_expires = this.storage.getItem("token_expires");
    if (token_expires && new Date(token_expires) < new Date()) {
      this.auth.refresh().then(result => {
        request = this.configureRequest(request);
        return next.handle(request);
      }, error => {
        this.router.navigate(['/auth/logout']);
        return this.abandonWithError('API error: Refresh token has expired');
      });
    }

    return next.handle(request).pipe(catchError(error => {

      // Log except 402, 404 or 409 from the api 
      if (!request.url.toLowerCase().startsWith(this.apiBaseUrl.toLowerCase()) || (error.status !== 402 && error.status !== 404 && error.status !== 409)) {
      }

      if (error.status === 401) {
        this.auth.refresh().then(result => {
          request = this.configureRequest(request);
          return next.handle(request);
        }, error => {
          this.router.navigate(['/auth/logout']);
          return this.abandonWithError('API error: HTTP 401 response');
        });
      }

      return observableThrowError(error);
    }));
  }

  abandonWithError(message) {
    return observableThrowError({
      status: 401,
      decription: message
    });
  }
}
